import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { Account } from '@libs/src/models/account.model';
import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

const defaultVisibleOpportunitiesCount = 3;

@Component({
  selector: 'app-profile-opportunities',
  templateUrl: './profile-opportunities.component.html',
})
export class ProfileOpportunitiesComponent implements OnChanges {
  @Input() opportunities: Opportunity[] = [];
  @Input() user: Account;
  @Input() totalCount: any;
  @Output() getOpportunities = new EventEmitter();
  isLoading = false;
  visibleOpportunitiesCount = defaultVisibleOpportunitiesCount;

  ngOnChanges() {
    this.isLoading = false;
    this.visibleOpportunitiesCount = this.opportunities.length;
  }

  getMoreOpportunities() {
    if (this.opportunities.length === this.totalCount) {
      this.visibleOpportunitiesCount = this.totalCount;
      return;
    }
    this.isLoading = true;
    this.getOpportunities.emit();
  }
}
